import { MenuOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCurrentUser } from '../../../hooks/data/user';
import logo from '../../../public/images/logo.svg';
import UserBlock from '../user-block';
import classes from './main-header.module.css';

const { Title } = Typography;

function MainHeader(props) {
   const { user } = useCurrentUser();
   const { type } = props;
   const router = useRouter();

   function handleBack() {
      router.push('/dashboard');
   }

   return (
      <div className={classes.main}>
         <Flex align="center" gap={16}>
            {props.onMenuClick && (
               <Button
                  className={classes.menuButton}
                  type="text"
                  onClick={props.onMenuClick}
                  icon={<MenuOutlined />}
                  aria-label="Open navigation menu"
               />
            )}
            {(type === 'templates' || type === 'elements') && (
               <Button
                  type="text"
                  size="small"
                  onClick={handleBack}
                  icon={<i className="fi fi-rr-angle-left" />}
               />
            )}
            <Link href="/dashboard">
               <Image src={logo} alt="logo" width={80} />
            </Link>
            <Title level={4} className={classes.pageTitle} style={{ margin: 0 }}>
               {type ? type.toUpperCase() : null}
            </Title>
         </Flex>
         {user && <UserBlock />}

         {!user && (
            <div className={classes.guest}>
               <div className={classes.login}>Login</div>
               <div className={classes.signup}>Signup</div>
            </div>
         )}
      </div>
   );
}

export default MainHeader;
